import { Grid, Skeleton } from "@mui/material";

interface ITFTModelHeaderLoaderProps {
	isUpdatable?: boolean;
}

export const TFTModelHeaderLoader = ({ isUpdatable }: Readonly<ITFTModelHeaderLoaderProps>) => {
	return (
		<Grid item xs={12}>
			<Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
				<Grid item>
					<Skeleton variant="rectangular" height={25} width={350} className="rounded-md" />
				</Grid>

				{isUpdatable && (
					<Grid item className="pr-0">
						<Grid container direction="row" justifyContent="space-between" spacing={6}>
							<Grid item>
								<Skeleton variant="rectangular" height={30} width={120} className="rounded-md" />
							</Grid>
							<Grid item>
								<Skeleton variant="rectangular" height={30} width={120} className="rounded-md" />
							</Grid>
						</Grid>
					</Grid>
				)}
			</Grid>
		</Grid>
	);
};
